import React from 'react';
import PropTypes from 'prop-types';
import useAuth from 'src/hooks/useAuth';
import LoadingScreen from 'src/components/LoadingScreen';

// ----------------------------------------------------------------------

AuthProtectOverpayment.propTypes = {
  children: PropTypes.node
};

const home_url = process.env.REACT_APP_DOMAIN;

function AuthProtectOverpayment({ children }) {
  const { isLoading, isAuthenticated, user } = useAuth();

  let staffAccess = user.staffAccess;

  
  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated || (user.isStaff && !staffAccess.includes('creditNote'))) {
    window.location = `${home_url}/unauthorized`
    return <LoadingScreen />
  }

  return <>{children}</>;
}

export default AuthProtectOverpayment
